import React from 'react';
import styled from 'styled-components';
import { Grid } from '../../app/StyleGuide';
import RestrictedAccessHeader from '../../components/RestrictedAccessHeader';
import { PrimaryButton } from '../../components/Buttons';
import { useUser } from '../authentication';
import WhiteLabel from '../../filters/WhiteLabel';
import { logout } from '../authentication';

const LogoutButton = styled(PrimaryButton)`
  margin-top: ${Grid._6};
`;

export const UnauthorizedAccount = () => {
  const { user } = useUser();

  return (
    <RestrictedAccessHeader
      title="Action Required"
      description={
        <>
          We&apos;re sorry. We couldn&apos;t find <strong>{user ? user.logInEmail : 'this user'}</strong> in our list of
          people in <strong>{WhiteLabel.name}</strong>.
        </>
      }
    >
      <p>Please log in with a Lifeway Id that is part of {WhiteLabel.name} or contact support to resolve this issue.</p>
      <LogoutButton onClick={logout}>Login with Another Account</LogoutButton>
    </RestrictedAccessHeader>
  );
};
